const dualList = {
  pickedAmount: '{{picked}} von {{total}} ausgewählten Elementen',
};

export default dualList;
